export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SET_OPTION_LIST = 'SET_OPTION_LIST';
export const SET_SEARCH_PARAM = 'SET_SEARCH_PARAM';
export const SET_OPTION_CODE_LIST = 'SET_OPTION_CODE_LIST';
export const SET_OPTION_PLANT_LIST = 'SET_OPTION_PLANT_LIST';
export const SET_SCREEN_LIST = 'SET_SCREEN_LIST';

export default {
	DEFAULT_ASSIGN,
	SET_OPTION_LIST,
	SET_OPTION_PLANT_LIST,
	SET_SEARCH_PARAM,
	SET_OPTION_CODE_LIST,
	SET_SCREEN_LIST
};
